import React from 'react';
import { Container, Row, Col, Tab, Tabs } from 'react-bootstrap';
import StageManagement from '../components/admin/StageManagement';
import JobManagement from '../components/admin/JobManagement';
import EmailTemplateManagement from '../components/admin/EmailTemplateManagement';
import UserManagement from '../components/admin/UserManagement';

const AdminPage: React.FC = () => {
    return (
        <Container fluid className="mt-4">
            <Row>
                <Col>
                    <h2>Admin Panel</h2>
                    <hr />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Tabs
                        defaultActiveKey="stages"
                        id="admin-tabs"
                        className="mb-3"
                    >
                        <Tab eventKey="stages" title="Stage Management">
                            <StageManagement />
                        </Tab>
                        <Tab eventKey="jobs" title="Job Management">
                            <JobManagement />
                        </Tab>
                        <Tab eventKey="emailTemplates" title="Email Templates">
                            <EmailTemplateManagement />
                        </Tab>
                        <Tab eventKey="users" title="User Management">
                            <UserManagement />
                        </Tab>
                        <Tab eventKey="settings" title="System Settings">
                            <p>System settings functionality will be implemented in a future update.</p>
                        </Tab>
                    </Tabs>
                </Col>
            </Row>
        </Container>
    );
};

export default AdminPage;